// Module
var code = `<div class="terceraButton {{.terceraButtonStyle}} {{.additionalClass}}"
     style="{{#.zIndex}}z-index:{{.zIndex}};{{/}}"
     on-mousedown="componentMouseDown"
     on-click='componentClick'
     on-mouseover="componentOver"
     on-mouseenter="componentEnter"
     on-mouseleave="componentLeave"
     {{^.enabled}}disabled="" {{/}}
     {{#if .focused}}focused{{/if}}
     {{#.checked}}checked{{/}}
     as-tooltip="tooltip"
     style="{{>visibility}}">

    {{#if .isColoringButton}}
    <div class="coloringButton-plate" style="background:url({{.coloringButtonImage}}) center center no-repeat transparent;"></div>
    <div class="coloringButton-color" style="background-color:{{.coloringButtonColor}};">{{.BackText}}</div>
    {{/if}}

    {{#if .image}}
    <span class="js-button-img" as-tooltip="tooltip"
          style="background:url({{ .enabled && .checked && .imageChecked ? .imageChecked : .image }}) center center no-repeat;">
    </span>
    {{/if}}

    {{#if .SVG}}
    <svg>
        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{.name}}"></use>
    </svg>
    {{/if}}

    {{#if .text}}
    <div class="js-text">{{.text}}</div>
    {{/if}}

    {{^.enabled}}<div class="js-disabled-icon"></div>{{/}}
</div>`;
// Exports
export default code;